import { render, staticRenderFns } from "./AllBlogs.vue?vue&type=template&id=531c2816"
import script from "./AllBlogs.vue?vue&type=script&lang=js"
export * from "./AllBlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports